import { useState } from 'react';
import { Container, TextField, Button } from "@mui/material";
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import BackButton from '../components/BackButton.jsx';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase.js';


// A form to handle adding a dish to the menu
function AddDish() {

  const { state } = useLocation();
  const { categoryInfo } = state;

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [price, setPrice] = useState(0);
  const [description, setDescription] = useState("");
  const [imagePath, setImagePath] = useState("");

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  // const handleImagePathChange = (event) => {
  //   setImagePath(event.target.value);
  // };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Update the dishInfo in the state or send the updated values to the backend
    if (addDishImage) {
      try {
        const body = {
          name,
          imagePath,
          description,
          price,
          ingredients_list: [],
          available_extras_list: [],
          category: categoryInfo.id 
        }
        const res = await fetch(`/menu/add_dish`, {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-type': 'application/json',
          }
        })

        // Upload to firebase
        const urlCategory = imagePath
        const storageRef = ref(storage, urlCategory);
        try {
          await uploadBytes(storageRef, addDishImage);
          alert('Photo uploaded successfully!');
        } catch (error) {
          console.error('Error uploading file:', error);
          alert('Failed to upload file!');
        }
      } catch (err) {
        // console.log(categoryPosition + position);
        console.log(err.message);
      }
      navigate(-1);
    } else {
      alert('Please select a file.');
    }
  }

  const [addDishImage, setAddDishImage] = useState(null);
  const handleDishImageChange = (e) => {
    setAddDishImage(e.target.files[0]);
    setImagePath('images/dishes/' + e.target.files[0].name)
  };

  return (
    <Box sx={{display: 'flex', flexDirection:'column', height: '100%', alignItems: 'center'}}>
      <Box sx={{maxWidth: { sx:1 }, overflowY: 'scroll', height: 4/5}}>
        <BackButton />
        <Container sx={{maxWidth: { sx:1, md: 3/5 }}}>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Name"
              value={name}
              onChange={handleNameChange}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="Price"
              value={price}
              onChange={handlePriceChange}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            <TextField
              label="Description"
              value={description}
              onChange={handleDescriptionChange}
              fullWidth
              margin="normal"
              variant="outlined"
            />
            {/* <TextField
              label="ImagePath"
              value={imagePath}
              onChange={handleImagePathChange}
              fullWidth
              margin="normal"
              variant="outlined"
            /> */}
            <input 
              id='image'
              onChange={handleDishImageChange}
              type="file"
            />
            <br/>
            <Button type="submit" variant="contained" color="primary" sx={{
                                            mt: '10px',
                                            bgcolor:'black',
                                            color:'white',
                                            mb: '10px',
                                            '&:hover': {
                                              backgroundColor: '#777778',
                                            }
                                          }}>
              Save
            </Button>
          </form>
        </Container>
      </Box>
    </Box>
  );
}

export default AddDish;